// extracted by mini-css-extract-plugin
export default {"tooltip":"eo-z","sharingV2":"fo-z","sharingIconsV2":"go-z","links":"ho-z","link":"io-z","facebookV2":"jo-z","twitterV2":"ko-z","pinterestV2":"lo-z"};